"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFormatterWidget = exports.TextFormatterDisplayWidget = exports.DefaultAllowedTags = exports.TextFormatterNames = exports.TextFormatterIcon = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Localize_1 = require("../../../gen-src/Localize");
var Colors_1 = require("../../styles/Colors");
var Declarative_1 = require("../../utils/Declarative");
var DomUtil_1 = require("../../utils/DomUtil");
var ToggleTextWidget_1 = require("../ToggleTextWidget");
var TextFormatterDisplayWidget_1 = require("./TextFormatterDisplayWidget");
Object.defineProperty(exports, "DefaultAllowedTags", { enumerable: true, get: function () { return TextFormatterDisplayWidget_1.DefaultAllowedTags; } });
Object.defineProperty(exports, "TextFormatterDisplayWidget", { enumerable: true, get: function () { return TextFormatterDisplayWidget_1.TextFormatterDisplayWidget; } });
var TextFormatterEditorWidget_1 = require("./TextFormatterEditorWidget");
var TextFormatterToolbar_1 = require("./TextFormatterToolbar");
var TextFormatterIcons_1 = require("../../icons/TextFormatterIcons");
Object.defineProperty(exports, "TextFormatterIcon", { enumerable: true, get: function () { return TextFormatterIcons_1.TextFormatterIcon; } });
Object.defineProperty(exports, "TextFormatterNames", { enumerable: true, get: function () { return TextFormatterIcons_1.TextFormatterNames; } });
var TextFormatterTestId = 'markup-editor';
var LabelContainerStyleName = TypeStyle.style({
    alignItems: 'baseline',
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: 24,
});
var HiddenStyleName = TypeStyle.style({
    visibility: 'hidden',
});
var MarkupContainerStyleName = TypeStyle.style({
    minWidth: TextFormatterDisplayWidget_1.TextFormatterMinWidth,
    position: 'relative',
});
var PseudoTextAreaStyleName = TypeStyle.style({
    border: "1px solid " + Colors_1.TextFieldBorderColors.Rest,
    boxSizing: 'border-box',
    fontSize: 12,
    overflow: 'auto',
    padding: 8,
});
var TextFormatterDisplayStyleName = TypeStyle.style({
    height: "calc(100% - " + TextFormatterToolbar_1.TextFormatterToolbarHeight + "px)",
    marginTop: TextFormatterToolbar_1.TextFormatterToolbarHeight,
    position: 'absolute',
    top: 0,
    width: '100%',
    $nest: {
        '& > :first-child': {
            marginTop: 0,
        },
    }
});
var ModeToggleButton = function (_a) {
    var inPreviewMode = _a.inPreviewMode, onClick = _a.onClick;
    // TODO change this to an Icon toggle when design is finalized
    return React.createElement(ToggleTextWidget_1.ToggleTextWidget, { ariaLabel: Localize_1.Messages.editorMode(), leftToggleText: Localize_1.Messages.edit(), handleLeftToggleSelected: inPreviewMode ? onClick : null, rightToggleText: Localize_1.Messages.preview(), handleRightToggleSelected: inPreviewMode ? null : onClick, selectedToggle: inPreviewMode ? ToggleTextWidget_1.SelectedToggle.Right : ToggleTextWidget_1.SelectedToggle.Left, testId: 'EditorModeToggleButton' });
};
var TextFormatterWidget = function (props) {
    var allowedTags = props.allowedTags, disabled = props.disabled, initialEditorMode = props.initialEditorMode, label = props.label, markup = props.markup, message = props.message, onChange = props.onChange, previewClassName = props.previewClassName, testId = props.testId, valid = props.valid, htmlAttrs = tslib_1.__rest(props, ["allowedTags", "disabled", "initialEditorMode", "label", "markup", "message", "onChange", "previewClassName", "testId", "valid"]);
    var _a = React.useState(props.initialEditorMode === 'preview'), inPreviewMode = _a[0], setInPreviewMode = _a[1];
    var textAreaId = React.useState(DomUtil_1.generateId())[0];
    var handleModeToggleClick = React.useCallback(function () {
        setInPreviewMode(!inPreviewMode);
    }, [setInPreviewMode, inPreviewMode]);
    return React.createElement("div", tslib_1.__assign({}, htmlAttrs, { "data-tb-test-id": Declarative_1.makeTestId(testId, '-TextFormatterWidget') }),
        React.createElement("div", { className: LabelContainerStyleName },
            React.createElement("label", { htmlFor: textAreaId }, label),
            React.createElement(ModeToggleButton, { inPreviewMode: inPreviewMode, onClick: handleModeToggleClick })),
        React.createElement("div", { className: MarkupContainerStyleName },
            React.createElement(TextFormatterEditorWidget_1.TextFormatterEditorWidget, { className: TypeStyle.classes(inPreviewMode && HiddenStyleName), disabled: disabled || inPreviewMode, disabledTooltipText: inPreviewMode ? Localize_1.Messages.textEditorDisabledPreviewMode() : undefined, id: textAreaId, label: null, markup: markup, message: message || React.createElement("br", null), onChange: onChange, testId: TextFormatterTestId, valid: valid }),
            inPreviewMode && React.createElement(TextFormatterDisplayWidget_1.TextFormatterDisplayWidget, { allowedTags: allowedTags, "aria-label": Localize_1.Messages.preview(), className: TypeStyle.classes(previewClassName, TextFormatterDisplayStyleName, PseudoTextAreaStyleName, !inPreviewMode && HiddenStyleName), markup: markup, testId: TextFormatterTestId })));
};
exports.TextFormatterWidget = TextFormatterWidget;
exports.TextFormatterWidget.defaultProps = { testId: '' };
exports.TextFormatterWidget.displayName = 'TextFormatterWidget';
//# sourceMappingURL=TextFormatterWidget.js.map